<template>
  <div class="container table-template">
    <BRow class="mb-4">
      <BCol>
        <span v-if="partner" class="partner">{{ partner.name }}</span>
      </BCol>
      <BCol class="clearfix">
        <BButton
          v-if="add_code_button"
          @click="createCodeModal = true"
          class="float-right btn-orange-blue"
          >Add Code</BButton
        >
      </BCol>
    </BRow>

    <BFormGroup
      horizontal
      label="Filter"
      class="d-md-none not-generic-form"
      id="codeOptions"
    >
      <BInputGroup>
        <BFormSelect v-model="sortBy" :options="sortCodeOptions">
          <option slot="first" :value="null">-- Filter --</option>
        </BFormSelect>
        <BFormSelect :disabled="!sortBy" v-model="sortDesc" slot="append">
          <option :value="false">Asc</option>
          <option :value="true">Desc</option>
        </BFormSelect>
      </BInputGroup>

      <BInputGroup class="border-search">
        <BFormInput v-model="filter" placeholder="Type to Search" />
        <BInputGroup-append>
          <i class="fa fa-search my-auto"></i>
        </BInputGroup-append>
      </BInputGroup>
    </BFormGroup>

    <div class="row rounded-top reg-codes">
      <div class="lock-codes">
        <img :src="'/images/lock.png'" />
        <span class="table-title">Registration Codes</span>
      </div>
      <div class="border-search d-none d-md-block">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="filter"
            placeholder="Type to Search"
          />
          <div class="input-group-append">
            <i class="fa fa-search my-auto"></i>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="!loading" key="table">
        <div class="row justify-content-center">
          <BTable
            stacked="md"
            :items="codes"
            :fields="codeFields"
            :filter="filter"
            empty-filtered-text="No registration codes match filters"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :per-page="10"
            :current-page="currentPage"
          >
            <template v-slot:cell(ta_consultant)="data">
              {{
                data.item.ta_consultant ? data.item.ta_consultant.name : "--"
              }}
            </template>
            <template v-slot:cell(partner)="data">
              {{ data.item.partner ? data.item.partner.name : "--" }}
            </template>
            <template v-slot:cell(partner_status)="data">
              {{ data.item.partner && data.item.partner.inactive ? "Inactive" : "Active" }}
            </template>
            <template v-slot:cell(actions)="{ item }">
              <div class="button-container">
                <BButton
                  size="sm"
                  @click="openInvites(item)"
                  variant="primary"
                  class="mt-1"
                >
                  Invites
                </BButton>
                <BButton
                  v-if="userRole == 'site-admin' || userRole == 'super-user'"
                  size="sm"
                  @click="editCode(item)"
                  variant="success"
                  class="mt-1"
                >
                  Edit
                </BButton>
              </div>
            </template>
          </BTable>
        </div>
        <BRow class="pagination-row justify-content-center">
          <BPagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            hide-goto-end-buttons
          />
        </BRow>
      </div>
      <div
        class="row justify-content-center border border-info border-top-0"
        v-else
        key="loading"
      >
        <div class="fa-3x">
          <i class="fas fa-spinner fa-pulse" style="color: #91ccda"></i>
        </div>
      </div>
    </transition>

    <BModal
      v-model="createCodeModal"
      hide-footer
      title="Create Registration Code"
      class="invites-modal"
      tabindex="-1"
    >
      <create-code-form
        @codeCreated="codeCreatedListener"
        :partners="partners"
        :consultants="consultants"
      ></create-code-form>
    </BModal>

    <BModal
      v-model="editCodeModal"
      hide-footer
      title="Edit Registration Code"
      class="invites-modal"
    
    >
      <edit-code-form
        :value="selectedCode"
        :partners="partners"
        :consultants="consultants"
        @confirmCodeDelete="confirmCodeDeleteListener"
        @updateCode="updateCode"
        tabindex="-1"
      ></edit-code-form>
    </BModal>

    <BModal
      v-model="invitesModal"
      size="lg"
      hide-footer
      class="invites-modal"
      :title="'Invites for code ' + selectedCode.code"
      @hide="invitesCode = null"
    >
      <invites
        :registration-code="selectedCode"
        :refresh-invites="refreshInvites"
        ref="inviteList"
      ></invites>

      <BRow class="mt-3">
        <BCol class="text-left">
          <button
            class="btn btn-orange-blue"
            :disabled="!selectedCode.is_valid"
            @click="showCreateInviteModal"
          >
            New Invite
          </button>
          <div
            v-show="!selectedCode.is_valid"
            class="text-center alert alert-danger my-2"
          >
            {{ codeIsInvalidText }}
          </div>
        </BCol>
      </BRow>
    </BModal>

    <BModal
      v-model="createInviteModal"
      hide-footer
      title="New Invite"
      class="invites-modal"
    >
      <create-invite-form
        :code="selectedCode"
        @inviteCreated="inviteCreatedListener"
        ref="createInviteForm"
      ></create-invite-form>
    </BModal>

    <BModal
      v-model="previewInviteModal"
      size="lg"
      hide-footer
      title="Preview Invite"
      class="invites-modal"
    >
      <preview-invite
        :user-role="userRole"
        :user-email="userEmail"
        :user-name="userName"
        :previewInviteId="previewInviteId"
        @inviteSent="inviteSentListener"
        @inviteDeleted="inviteDeletedListener"
      ></preview-invite>
    </BModal>

    <BModal
      v-model="confirmModal"
      hide-footer
      title="Confirm Delete"
      class="invites-modal"
    >
      Do you really want to delete?
      <br /><br />
      <button class="btn btn-blue-blue float-right" @click="deleteCode()">
        Confirm Delete
      </button>
    </BModal>
  </div>
</template>

<style lang="scss">
@import "../../../sass/layout/tables";
</style>

<style>
.btn-success {
  color: #fff;
}
</style>

<style>
.button-container {
  display: flex;
}

/* Let the buttons grow and fill the available space equally */
.button-container .btn {
  flex-grow: 1;

  /* Add margin to create spacing between buttons */
  margin-right: 5px; /* Adjust the value as needed */
}

/* Remove the margin from the last button to avoid extra space at the end */
.button-container .btn:last-child {
  margin-right: 0;
}
</style>

<script>
import CreateCodeForm from "./CreateCodeForm";
import EditCodeForm from "./EditCodeForm";
import Invites from "./Invites";
import CreateInviteForm from "./CreateInviteForm";
import PreviewInvite from "./PreviewInvite";
import urlPolyfill from "url-polyfill";

export default {
  name: "RegistrationCodeList",
  components: {
    CreateCodeForm,
    EditCodeForm,
    Invites,
    CreateInviteForm,
    PreviewInvite,
  },
  props: ["user-role", "user-name", "user-email"],
  data() {
    return {
      codes: [],
      partners: [],
      consultants: [],
      codeFields: [
        {
          key: "code",
          label: "Code",
          sortable: true,
          thStyle: {
            width: "20%",
          },
        },
        {
          key: "partner",
          label: "Partner",
          sortable: true,
        },
        {
          key: "invites_sent",
          label: "Invites Sent",
          sortable: true,
          thStyle: {
            width: "75px",
          },
        },
        {
          key: "code_uses",
          label: "Code Uses",
          sortable: true,
          thStyle: {
            width: "75px",
          },
        },
        {
          key: "status",
          label: "Code Status",
          sortable: true,
          thStyle: {
            width: "75px",
          },
        },
        {
          key: "partner_status",
          label: "Partner Status",
          sortable: true,
          thStyle: {
            width: "75px",
          },
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: null,
      add_code_button: null,
      selectedCode: {},
      deleteCodeId: null,
      invitesCode: null,
      refreshInvites: {},
      createCodeModal: false,
      editCodeModal: false,
      confirmModal: false,
      invitesModal: false,
      invite: {},
      createInviteModal: false,
      previewInviteId: 0,
      previewInviteModal: false,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      partner: null,
      loading: true,
    };
  },
  watch: {
    createInviteModal: function (to, from) {
      if (!to) {
        this.$refs.createInviteForm.initNewInvite();
        this.$refs.createInviteForm.errors = [];
      }
    },
  },
  methods: {
    codeCreatedListener() {
      this.createCodeModal = false;
      this.getCodes();
    },
    editCode(code) {
      this.editCodeModal = true;
      this.selectedCode = code;
    },
    confirmCodeDeleteListener(payload) {
      this.editCodeModal = false;
      this.confirmModal = true;
      this.deleteCodeId = payload.id;
    },
    updateCode(updatedCode) {
      this.editCodeModal = false;
      this.getCodes();
      this.selectedCode = {};
    },
    openInvites(code) {
      this.invitesModal = true;
      this.selectedCode = code;
    },
    showCreateInviteModal() {
      this.invitesModal = false;
      this.createInviteModal = true;
    },
    inviteCreatedListener(payload) {
      this.createInviteModal = false;
      this.previewInviteModal = true;
      this.previewInviteId = payload.inviteCreatedId;
      if (this.$refs.inviteList) {
        this.$refs.inviteList.alertMessage = "Invite sent successfully";
      }
    },
    inviteSentListener(payload) {
      this.invitesModal = true;
      this.previewInviteModal = false;
      this.invite = {};
      this.getCodes();
      this.refreshInvites = true;
    },
    inviteDeletedListener() {
      this.previewInviteModal = false;
    },
    getCodes(params = {}) {
      var url = "/api/registration-codes";
      var partnerId = new URL(window.location).searchParams.get("partner_id");
      let query = params;
      let queryString = "";
      var queryDict = {};
      location.search
        .substr(1)
        .split("&")
        .forEach((item) => {
          queryDict[item.split("=")[0]] = item.split("=")[1];
        });
      if (queryDict.hasOwnProperty("partner_id")) {
        var partnerId = queryDict.partner_id;
      } else {
        var partnerId = null;
      }
      if (partnerId) {
        query.partner_id = partnerId;
      }
      if (Object.keys(query).length > 0) {
        queryString =
          "?" +
          Object.keys(query)
            .map((key) => key + "=" + query[key])
            .join("&");
      }
      console.log(queryString);
      return axios
        .get(url + queryString)
        .then((response) => {
          // Update the data of Btable
          this.loading = true;
          this.$nextTick(()=>{
            this.loading = false;
          })
          this.codes = response.data.data;
          this.totalRows = this.codes.length;
          return response;
        })
        .catch(function (error) {
          console.error(error);
          return error;
        });
    },
    fetchCodes(context, callback) {
      return this.getCodes({
        page: context.currentPage,
        size: context.perPage,
        orderBy: [context.sortBy, context.sortDesc],
        filter: context.filter,
      })
        .then((response) => {
          this.totalRows = response.data.meta.total;
          return response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return [];
        });
    },
    deleteCode() {
      axios
        .delete("/api/registration-codes/" + this.deleteCodeId)
        .then(
          function (response) {
            this.confirmModal = false;
            this.deleteCodeId = null;
            this.getCodes();
          }.bind(this)
        )
        .catch(function (error) {
          console.error(error);
        });
    },
    getPartners() {
      axios
        .get("/api/partners")
        .then(
          function (response) {
            this.partners = response.data.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.error(error);
        });
    },
    // getConsultants() {
    //   axios
    //     .get("/api/consultants")
    //     .then(
    //       function (response) {
    //         this.consultants = response.data.data;
    //       }.bind(this)
    //     )
    //     .catch(function (error) {
    //       console.error(error);
    //     });
    // },
    getPartner() {
      console.log("getting partners");
    },
  },

  computed: {
    partner_options: function () {
      let options = [];
      for (var i = 0; i < this.partners.length; i++) {
        options.push({
          value: this.partners[i].id,
          text: this.partners[i].name,
        });
      }
      return options;
    },
    consultant_options: function () {
      let options = [];
      for (var i = 0; i < this.consultants.length; i++) {
        options.push({
          value: this.consultants[i].id,
          text: this.consultants[i].name,
        });
      }
      return options;
    },
    admin_to_partner: function () {
      if (
        this.userRole == "site-admin" &&
        this.invite.to_role == "partner-user"
      ) {
        return true;
      }
      return false;
    },
    sortCodeOptions: function () {
      if (this.codeFields) {
        return this.codeFields
          .filter((f) => f.sortable)
          .map((f) => {
            return { text: f.label, value: f.key };
          });
      }
      return new Array();
    },
    codeIsInvalidText: function () {
      if (this.selectedCode) {
        if (!this.selectedCode.is_valid) {
          if (!this.selectedCode.enabled) {
            return "This registration code has been disabled.";
          }
          return "The partner associated with this registration code is inactive.";
        }
        return "Registration code is valid.";
      }
      return "No registration code has been selected";
    },
  },

  mounted() {
    if (this.userRole == "super-user" || this.userRole == "site-admin") {
      this.add_code_button = true;
    }
    this.getPartner();
    this.getPartners();
    // this.getConsultants();
    this.getCodes();
  },
};
</script>
